export default __webpack_public_path__ + "static/media/img7.774cd1b2.png";